export default __webpack_public_path__ + "static/media/programme.ea441d4b.png";